import React from 'react';
import '../../App.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function Contacts() {
  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  const handlePhoneClick = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  const cardStyle = {
    width: 300,
    height: '100%',
    padding: 2,
    borderRadius: 3,
    boxShadow: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(4px)'
  };

  const linkStyle = {
    cursor: 'pointer',
    color: '#1976d2',
    textDecoration: 'underline'
  };

  return (
    <Box className='contact_background' sx={{ padding: 4 }}>
      <Box className='cards__container' sx={{ display: 'flex', gap: 4, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Card sx={cardStyle}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              <strong>Valdybos pirmininkas</strong>
            </Typography>
            <Typography variant="body1">Romas Kukis</Typography>
            <Typography variant="body2" sx={linkStyle} onClick={() => handleEmailClick('romaskukis@gmail.com')}>
              romaskukis@gmail.com
            </Typography>
            <Typography variant="body2" sx={linkStyle} onClick={() => handlePhoneClick('+37069826465')}>
              +370 698 26465
            </Typography>
            <Typography variant="body2">Pilies 12 g., Nr. 3</Typography>
            <Typography variant="body2">Kumelionių km., Marijampolės sav.</Typography>
          </CardContent>
        </Card>

        <Card sx={cardStyle}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              <strong>Buhalterė</strong>
            </Typography>
            <Typography variant="body1">Rūta Geležienė</Typography>
            <Typography variant="body2" sx={linkStyle} onClick={() => handlePhoneClick('+37063427984')}>
              +370 634 27984
            </Typography>
            <Typography variant="body2">AS: LT 917181800001462093</Typography>
            <Typography variant="body2">Bankas „Artea“</Typography>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
